export const getDefaultTimezone = () => {
  const date = new Date();
  const offset = date.getTimezoneOffset();
  let str;
  switch (offset) {
    case 360:
      str = "US/Central";
      break;
    case 420:
      str = "US/Mountain";
      break;
    case 480:
      str = "US/Pacific";
      break;
    default:
      str = "US/Eastern";
      break;
  }

  return str;
};
export const defaultTimezone = getDefaultTimezone();
export const extractModel = {
  builder_version: 1.0,
  account_id: "",
  dag_id: "",
  name: "",
  datasets: [],
  description: "",
  fields: [],
  filters: [],
  schedule: "",
  timezone: defaultTimezone,
  expiration: "",
};
